import React, { useState, useRef } from "react";

const FormTodo = ({ addTodo }) => {
  const [list, setList] = useState("");
  const reset = useRef();

  const handleFormSubmit = (ev) => {
    ev.preventDefault();
    addTodo(list);
    setList("");
    clearInput();
  };

  const clearInput = () => {
    reset.current.value = "";
  };

  const handleInputChange = (ev) => {
    setList(ev.target.value);
  };

  return (
    <form className="w-full" onSubmit={handleFormSubmit}>
      <input
        type="text"
        className="w-full shadow rounded px-3 py-1 text-gray-700"
        onChange={handleInputChange}
        ref={reset}
      />
    </form>
  );
};

export default FormTodo;
